const translations = {
    johnDeere: 'John Deere™'
};

export default translations;
